/**
 * Dialogue de confirmation affiché quand une sauvegarde est bloquée par un format de document
 * obsolète (voir `core/FormatMigrationGate.ts`, BESOINS.md §8.x) — décision volontairement binaire
 * ("Oui"/"Non"), pas de fermeture par clic extérieur ni par Échap (contrairement à `ContextMenu`) :
 * l'utilisateur doit explicitement choisir, la modification en attente restant bloquée sinon.
 */
export class MigrationDialog {
  private element: HTMLDivElement | null = null;

  constructor(private container: HTMLElement) {}

  /** Résout `true` si l'utilisateur clique "Oui", `false` s'il clique "Non" — dans les deux cas,
   * le dialogue est démonté juste avant la résolution. */
  confirm(): Promise<boolean> {
    this.close();

    return new Promise<boolean>((resolve) => {
      const overlay = document.createElement("div");
      overlay.className = "toka-migration-dialog-overlay";

      const dialog = document.createElement("div");
      dialog.className = "toka-migration-dialog";

      const title = document.createElement("div");
      title.className = "toka-migration-dialog__title";
      title.textContent = "Mise à jour du format nécessaire";
      dialog.appendChild(title);

      const text = document.createElement("div");
      text.className = "toka-migration-dialog__text";
      text.textContent =
        "Votre carte utilise un ancien format de données. Tant qu'elle n'est pas migrée vers le " +
        "nouveau format, aucune modification ne peut être enregistrée. Migrer maintenant ?";
      dialog.appendChild(text);

      const actions = document.createElement("div");
      actions.className = "toka-migration-dialog__actions";

      const settle = (accepted: boolean) => {
        this.close();
        resolve(accepted);
      };

      const yesButton = document.createElement("button");
      yesButton.type = "button";
      yesButton.className = "toka-migration-dialog__yes-button";
      yesButton.textContent = "Oui";
      yesButton.addEventListener("click", () => settle(true));
      actions.appendChild(yesButton);

      const noButton = document.createElement("button");
      noButton.type = "button";
      noButton.className = "toka-migration-dialog__no-button";
      noButton.textContent = "Non";
      noButton.addEventListener("click", () => settle(false));
      actions.appendChild(noButton);

      dialog.appendChild(actions);
      overlay.appendChild(dialog);
      this.container.appendChild(overlay);
      this.element = overlay;
    });
  }

  private close(): void {
    this.element?.remove();
    this.element = null;
  }
}
